import React, { FC } from 'react';
import { useGetStoreInfiniteList } from '@services/store/hooks/useGetStoreList';
import { getStoreItemsSortQuery, LinksEnum, PageQueries } from '@specs/navigation';
import { useRouter } from 'next/router';
import { toy } from '@specs/specs';
import { StoreItem } from '@components/Cards/StoreItem/StoreItem';
import { InfinityList } from '@components/InfinityList/InfinityList';
import { Button } from '@components/UIKit/Button/Button';
import { useTranslation } from '@hooks/useTranslation';
interface Props {
  toyId: toy['id'];
  slug: toy['slug'];
  toyName: toy['name'];
  inView: boolean;
}
const limit = 5;
export const List: FC<Props> = ({
  toyId,
  slug,
  toyName,
  inView
}) => {
  const {
    translate: tr
  } = useTranslation();
  const router = useRouter();
  const {
    storeItemsSort,
    priceSortCurrency
  }: PageQueries = router.query;
  const {
    data,
    status,
    hasNextPage
  } = useGetStoreInfiniteList({
    toyid: toyId,
    sort: getStoreItemsSortQuery(storeItemsSort),
    limit,
    currency: priceSortCurrency
  }, {
    enabled: inView
  });
  const clickHandler = async () => {
    await router.push({
      pathname: LinksEnum.TOY_SELLERS,
      query: {
        slug
      }
    });
  };
  return <>
            <InfinityList data={data} enabledRef={undefined} isFetchingNextPage={false} status={status} hasNextPage={false} fetchNextPage={() => {}} data-sentry-element="InfinityList" data-sentry-source-file="List.tsx">
                {(item, _, pageIndex) => {
        if (pageIndex > 0 || typeof item.instanceid !== 'number') return;
        return <StoreItem key={item.id} {...item} instanceid={item.instanceid} toyName={toyName} />;
      }}
            </InfinityList>
            {hasNextPage && <Button id='offers_collection_view_all_button' color={'Transparent'} size={'medium'} onClick={clickHandler}>
                    {tr({
        id: 'btn.view.all'
      })}
                </Button>}
        </>;
};